import { render } from "./MedicineList.vue?vue&type=template&id=5f5320ce&scoped=true"
import script from "./MedicineList.vue?vue&type=script&lang=js"
export * from "./MedicineList.vue?vue&type=script&lang=js"

import "./MedicineList.vue?vue&type=style&index=0&id=5f5320ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5320ce"]])

export default __exports__